import _decorate from "@babel/runtime/helpers/esm/decorate";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "@babel/runtime/helpers/esm/get";
function _superPropGet(t, e, r, o) { var p = _get(_getPrototypeOf(1 & o ? t.prototype : t), e, r); return 2 & o ? function (t) { return p.apply(r, t); } : p; }
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { property } from 'lit/decorators.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import StableSelectorMixin from "../../globals/mixins/stable-selector.js";
import C4DCard from "../card/card.js";
import "../image/image.js";
import styles from "././feature-card.css.js";
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';
const {
  prefix,
  stablePrefix: c4dPrefix
} = settings;

/**
 * Feature Card.
 *
 * @element c4d-feature-card
 */
let C4DFeatureCard = _decorate([customElement(`${c4dPrefix}-feature-card`)], function (_initialize, _StableSelectorMixin) {
  class C4DFeatureCard extends _StableSelectorMixin {
    constructor(...args) {
      super(...args);
      _initialize(this);
    }
  }
  return {
    F: C4DFeatureCard,
    d: [{
      kind: "field",
      decorators: [property()],
      key: "size",
      value: void 0
    }, {
      kind: "method",
      key: "updated",
      value:
      /**
       * The size property to render either Medium (default) or Large Feature Card variants.
       */

      function updated(changedProperties) {
        _superPropGet(C4DFeatureCard, "updated", this, 3)([changedProperties]);
        const {
          _linkNode: linkNode
        } = this;
        if (linkNode) {
          linkNode.classList.remove(`${prefix}--link`);
          linkNode.classList.add(`${prefix}--feature-card__card`);
        }
      }
    }, {
      kind: "get",
      static: true,
      key: "stableSelector",
      value: function () {
        return `${c4dPrefix}--feature-card`;
      }

      /**
       * A selector that will return the child footer.
       */
    }, {
      kind: "get",
      static: true,
      key: "selectorFooter",
      value: function () {
        return `${c4dPrefix}-feature-card-footer`;
      }
    }, {
      kind: "field",
      static: true,
      key: "styles",
      value() {
        return styles;
      }
    }]
  };
}, StableSelectorMixin(C4DCard));
/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DFeatureCard;
//# sourceMappingURL=feature-card.js.map
